module.exports = __webpack_public_path__ + "img/logo.51b5320a.png";